<div class="rx-intuitive-treatment-toolbar">
	<div class="rx-intuitive-treatment-toolbar__tabs">
		<button
			tlkButton
			class="rx-intuitive-treatment-toolbar__tooth-chart-tab"
			[variant]="currentOrchestratorViewMode === orchestratorViewMode.chart ? 'primary' : 'secondary'"
			size="m"
			(click)="switchViewMode(orchestratorViewMode.chart)"
		>
			{{ 'TeethDiagram.ToothChart' | translate }}
		</button>
		<button
			tlkButton
			class="rx-intuitive-treatment-toolbar__table-view-tab"
			[variant]="currentOrchestratorViewMode === orchestratorViewMode.table ? 'primary' : 'secondary'"
			size="m"
			[disabled]="tableViewDisabled"
			(click)="switchViewMode(orchestratorViewMode.table)"
		>
			{{ 'TeethDiagram.TableView' | translate }}
		</button>
	</div>

	<rx-copy-from-tooth-menu
		*ngIf="showCopyFromToothMenu"
		id="rx-intuitive-copy-from-tooth"
		[disabled]="isCopyFromToothControlDisabled$ | async"
		[sourceMenuItems]="(copyFromSourceMenuItems$ | async) ?? []"
		[defaultIndicationId]="copyFromMenuDefaultIndicationId"
		(sourceSelected)="onCopyFromToothSourceSelected($event)"
	/>
</div>
